<template>
    <div class="d-block">
        <page-banner v-bind:data="bannerData" v-if="bannerData"/>
        <div class="list-container" style="padding: 0 80px 160px 80px;">
            <div class="container">
                <Row :gutter="64">
                    <Col span="12" v-for="(item, index) in investList" :key="index">
                        <div class="invest-item">
                            <h1 class="d-block">{{ item.title }}</h1>
                            <br/>
                            <br/>
                            <br/>
                            <div class="square-128 radius-xxl bg-white" style="margin: auto; border: 1px solid #e8eaec;">
                                <span class="d-flex justify-center height-all">
                                    <img :src="item.icon" style="max-width: 85%; max-height: 85%;"/>
                                </span>
                            </div>
                            <br/>
                            <br/>
                            <p data-box="info" class="size-24 line-h-36 align-center">{{ item.introduction }}</p>
                            <br/>
                            <h6 class="align-center">
                                <a class="btn" @click="__onComments">{{ language === 'zh-cn' ? '联系源音' : 'Contact Us' }}</a>
                            </h6>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import PageBanner from "../../components/PageBanner";

    export default {
        components: {
            PageBanner
        },
        data () {
            return {
                language: 'zh-cn',
                bannerData: null,
                investList: [],
                total: 0,
                current: 1,
                pageSize: 10,
            }
        },
        created() {
            console.log('当前语言----->' + this.$store.state.language);
            this.language = this.$store.state.language;
        },
        mounted() {
            this.__getBanner();
            this.__getInvestList(1);
        },
        methods: {
            __getBanner(){
                this.$api.getHttp('banner?bannerType=INVEST', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.bannerData = res.data.data;
                        // console.log(this.bannerData);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __getInvestList(page){
                this.$api.getHttp('invest?pageIndex=' + page + "&pageSize=" + this.pageSize, {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.total = res.data.data.total;
                        this.investList = res.data.data.data;
                        console.log('<---------- res ---------->');
                        console.log(this.investList);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },
            __onComments(){
                this.$bus.emit('isComments', true);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/invest/list.vue